import React, { useEffect, useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import LeadPerformanceCardComponent from './LeadPerformanceCardComponent'
import { connect, useDispatch } from "react-redux";
import { fetchLeadPerformanceSummaryReport } from '../../Services/reports';

interface LeadPerformanceSummaryComponentProps {
    leadPerformanceScoreType: any,
    user: any,
    lqcReportDate: any
}

// const leadPerformanceData = [
//     {
//         cardTitle: "Lead Qualification Rate",
//         cardSubtitle: "Based  on the number of the leads who showed interest  upon calling",
//         totalQalificationPercent: "55.1",
//         inOneHourQalificationPercent: "30.4",
//         afterOneHourQalificationPercent: "23.1",
//         leadCallingScoreType: "good",
//     },
// ]

const LeadPerformanceSummaryComponent: React.FC<LeadPerformanceSummaryComponentProps> = ({ leadPerformanceScoreType, user, lqcReportDate }) => {
    const [reportsData, setReportsData] = useState<any>([]);
    leadPerformanceScoreType = leadPerformanceScoreType ? leadPerformanceScoreType.toLowerCase() : "";

    useEffect(() => {
        const setLeadPerformanceSummaryReport = async () => {
            await fetchLeadPerformanceSummaryReport(Number(user.user_super_oid), lqcReportDate, "Performance", setReportsData);
        };

        if (user.user_super_oid && lqcReportDate) {
            setLeadPerformanceSummaryReport();
        }
    }, [
        user.user_super_oid, lqcReportDate
    ]);
    return (
        <div className={styles.LqscsWrapper}>
            <div className={styles.LqscsTitle}>Performance 
                <span style={{marginLeft:"0.5rem"}}  className={`${styles.LqscsTitleTag} ${styles[leadPerformanceScoreType]}`}>{leadPerformanceScoreType && leadPerformanceScoreType.charAt(0).toUpperCase() + leadPerformanceScoreType.slice(1)}</span>
                </div>
            <div className={styles.LqspCards}>
                {
                    reportsData?.map((item: any, index: any) => {
                        return <LeadPerformanceCardComponent data={item} key={index} />
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        lqcReportDate: state.lqcReportData.lqcReportDate
    };
};

export default connect(mapStateToProps)(LeadPerformanceSummaryComponent);